import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import TableAirflow from './TableAirflow';
import { removeProjectTables, fetchProjects } from 'store/slices/project';

/**
 * Airflow Module Page
 * Wrapper component for Airflow DAG management
 * Route: /workspace/storage/:projectId/airflow
 * TableAirflow tự load DAGs qua fetchProjectAirflowDags / getProjectAirflowDags.
 */
const AirflowModulePage = ({ projectName, projectSubname, onBack }) => {
    const dispatch = useDispatch();
    const projectsState = useSelector((state) => state.project);

    useEffect(() => {
        if (projectName) {
            dispatch(removeProjectTables());
        }
    }, [projectName, dispatch]);

    const handleBack = () => {
        dispatch(removeProjectTables());
        dispatch(fetchProjects());
        onBack();
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    mb: 2,
                    px: 0
                }}
            >
                <IconButton
                    aria-label="Quay lại"
                    onClick={handleBack}
                    size="medium"
                    sx={{
                        bgcolor: 'grey.100',
                        '&:hover': { bgcolor: 'grey.200' }
                    }}
                >
                    <ArrowBackIosNewRoundedIcon fontSize="small" />
                </IconButton>
                <Box>
                    <Typography variant="h4" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                        Luồng công việc (Airflow)
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {projectSubname || projectName || 'Dự án'} · Quản lý DAG và lịch chạy
                    </Typography>
                </Box>
            </Box>
            <TableAirflow
                onClick={handleBack}
                folderName={projectName}
                projectSubname={projectSubname}
                dataMongoDBTable={projectsState?.dags_name ? [] : []}
                fetchProjectTables={() => {}}
                isSetting={false}
            />
        </Box>
    );
};

export default AirflowModulePage;
